var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4567 13.4043L48.8738 5.58263C48.7144 5.43705 48.5 5.3623 48.2836 5.38C48.0672 5.39574 47.8685 5.5 47.7308 5.66918L20.6029 39.1295L13.9951 30.0154C13.8692 29.8403 13.6764 29.7262 13.462 29.6967C13.2495 29.6672 13.0331 29.7282 12.8639 29.862L4.17278 36.8318C3.99573 36.9734 3.8895 37.1839 3.87966 37.4082C3.86983 37.6344 3.95638 37.8528 4.11769 38.0102L19.5406 52.9374C19.6882 53.079 19.8849 53.1597 20.0875 53.1597H20.1013C20.3098 53.1557 20.5105 53.0692 20.6541 52.9177L57.4941 14.5295C57.6416 14.3761 57.7203 14.1695 57.7124 13.959C57.7046 13.7485 57.6121 13.5459 57.4567 13.4043ZM20.0698 51.2593L5.85474 37.5026L9.81671 34.3256L19.9459 45.0921L52.2652 10.8016L55.8003 14.0239L20.0698 51.2593Z",
    fill: "#0C62FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e4459c0bb1f0f350c7b9c930cbc1571d.svg";
export { ForwardRef as ReactComponent };